import React from 'react';
import AssigneePickerMenu from 'flow/components/tickets/Assignee/AssigneePickerMenu';
import useUpdateTicketAssignee from 'flow/components/tickets/Assignee/useUpdateTicketAssignee';
import { TicketKey } from 'flow/types/EntityKeys';

type Props = {
    ticketKey: TicketKey;
};

// Rendered only while the chip's menu is open, so the assignment wiring
// (dispatch, modal, request state) only exists when it can actually be used.
const AssigneeChipPicker = ({ ticketKey }: Props) => {
    const { onSelect } = useUpdateTicketAssignee(ticketKey, 'tickets list');

    return (
        <AssigneePickerMenu
            ticketKey={ticketKey}
            onSelect={onSelect}
            anchor="bottom start"
        />
    );
};

export default React.memo(AssigneeChipPicker);
